import { render, staticRenderFns } from "./DashNegotiation.vue?vue&type=template&id=8886dec4&scoped=true&"
import script from "./DashNegotiation.vue?vue&type=script&lang=js&"
export * from "./DashNegotiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8886dec4",
  null
  
)

export default component.exports